import { EFetchStatus } from '../../types/listingOffers';
import { IApplicationState } from '../../types/redux';

/**
 * «Данных листинга ещё нет, но они будут» — INITIAL (не запрашивали) или LOADING (запрос идёт).
 * Для UI-скелетона листинга. НЕ путать с selectIsOffersLoading (===LOADING, реальный запрос),
 * который гейтит пагинацию: её завязывать на pending нельзя.
 */
export const selectIsListingPending = (state: IApplicationState) => {
  const { status } = state.listingOffers;

  return status === EFetchStatus.INITIAL || status === EFetchStatus.LOADING;
};
